import React, { lazy } from "react";

const MasterFrontLayoutV2 = lazy(() =>
  import("../layouts/frontend/MasterLayoutV2.js")
);
const FrontPage2 = lazy(() => import("../components/frontend/FrontPage2"));
const DiscountPageV2 = lazy(() =>
  import("../components/frontend/DiscountPageV2.js")
);
const ShopPage2 = lazy(() => import("../components/frontend/ShopPage2"));
const Login2 = lazy(() => import("../components/frontend/Login2"));
const ContactUs = lazy(() => import("../components/frontend/ContactUs"));
const OrderStep2 = lazy(() => import("../components/frontend/OrderStep2"));
const Landing2 = lazy(() => import("../components/frontend/Landing2"));
const CheckoutPageBeta = lazy(() =>
  import("../components/frontend/CheckoutPageBeta")
);
const Final2 = lazy(() => import("../components/frontend/Confirmation2"));
const MyAccountInfo2 = lazy(() =>
  import("../components/frontend/MyAccountInfo2")
);
const Dashboard2 = lazy(() => import("../components/frontend/Dashboard2"));
const ReferralPage2 = lazy(() =>
  import("../components/frontend/ReferralPage2")
);
const BonusPage2 = lazy(() => import("../components/frontend/BonusPage2"));
const BonusSlug2 = lazy(() => import("../components/frontend/BonusSlug2"));
const Cart2 = lazy(() => import("../components/frontend/Cart2"));
const Api = lazy(() => import("../components/frontend/Api"));
const Faq = lazy(() => import("../components/frontend/Faq"));
const SingleProduct2 = lazy(() =>
  import("../components/frontend/SingleProduct2")
);
const ForgetPassword2 = lazy(() =>
  import("../components/frontend/ForgetPassword2")
);
const ResetPassword2 = lazy(() =>
  import("../components/frontend/ResetPassword2")
);
const V12 = lazy(() => import("../components/frontend/V12"));
const V22 = lazy(() => import("../components/frontend/V22"));
const V1t2 = lazy(() => import("../components/frontend/v1t2"));
const V2t2 = lazy(() => import("../components/frontend/v2t2"));
const ChekoutTwo2 = lazy(() =>
  import("../components/frontend/CheckoutTwo2")
);
const TermAndCond = lazy(() =>
  import("../components/frontend/TermAndCond.js")
);
const PrivacyPolicy = lazy(() =>
  import("../components/frontend/PrivacyPolicy.js")
);
const Citations = lazy(() =>
  import("../components/frontend/Citations.js")
);
const CancelSubscription = lazy(() =>
  import("../components/frontend/CancelSubscription.js")
);
const TOST = lazy(() => import("../components/frontend/TOSTemplate.js"));
const RestrictionPage = lazy(() => import("../components/RestrictionPage.js"));
const PrivateRoutes = lazy(() =>
  import("../components/frontend/auth/PrivateRoutes")
);

export const PrivateRoutesGuard = PrivateRoutes;

export const frontendRoutes = [
  { path: "/no-access", element: <RestrictionPage /> },
  {
    path: "/",
    element: <MasterFrontLayoutV2 />,
    children: [
      { path: "/", element: <FrontPage2 /> },
      { path: "/login", element: <Login2 /> },
      { path: "/forget-password", element: <ForgetPassword2 /> },
      { path: "/reset-password", element: <ResetPassword2 /> },
      { path: "/discount", element: <DiscountPageV2 /> },
      { path: "/shop/:slug", element: <ShopPage2 /> },
      { path: "/create-membership", element: <Landing2 /> },
      { path: "/order-step-1", element: <OrderStep2 /> },
      { path: "/membership-checkout", element: <CheckoutPageBeta /> },
      { path: "/confirmation", element: <Final2 /> },
      { path: "/api", element: <Api /> },
      { path: "/faq", element: <Faq /> },
      { path: "/checkout-2", element: <ChekoutTwo2 /> },
      { path: "/tos", element: <TOST /> },
      {
        element: <PrivateRoutes />,
        children: [
          { path: "/my-account-info", element: <MyAccountInfo2 /> },
          { path: "/referral", element: <ReferralPage2 /> },
          { path: "/bonus", element: <BonusPage2 /> },
          { path: "/bonus/:slug", element: <BonusSlug2 /> },
        ],
      },
      { path: "/dashboard", element: <Dashboard2 /> },
      { path: "/contact-us", element: <ContactUs /> },
      { path: "/cart", element: <Cart2 /> },
      { path: "/product/:slug", element: <SingleProduct2 /> },
      { path: "/v1", element: <V12 /> },
      { path: "/v2", element: <V22 /> },
      { path: "/v1t", element: <V1t2 /> },
      { path: "/v2t", element: <V2t2 /> },
      { path: "/term-and-condition", element: <TermAndCond /> },
      { path: "/privacy-policy", element: <PrivacyPolicy /> },
      { path: "/citations", element: <Citations /> },
      {
        path: "/cancel-my-subscription",
        element: <CancelSubscription />,
      },
    ],
  },
];
